import { render, staticRenderFns } from "./resultBook.vue?vue&type=template&id=5c46d0c4&scoped=true&"
import script from "./resultBook.vue?vue&type=script&lang=js&"
export * from "./resultBook.vue?vue&type=script&lang=js&"
import style0 from "./resultBook.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./resultBook.vue?vue&type=style&index=1&id=5c46d0c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c46d0c4",
  null
  
)

export default component.exports